import { call, put, takeEvery } from "redux-saga/effects";
import { TransactionActionTypes } from "../actions/actionTypes";
import { downloadCsvFailure, downloadCsvSuccess } from "../actions/action";
import { transactionService } from "../../services/dependency.injection";

function* callDownloadCsv({ payload: value }) {
    const response = yield call(transactionService.downloadTransactionCsv, value);

    if (response.isRight()) {
        const blob = new Blob([response.value.getValue()], { type: 'text/csv' });
        const blobUrl = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobUrl;
        tempLink.download = 'transaction.csv';
        tempLink.setAttribute('target', '_blank');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobUrl);

        yield put(downloadCsvSuccess('It successfully downloaded'));
    } else {
        yield put(downloadCsvFailure(response.value));
    }
}

export function* watchCallDownloadCsv() {
    yield takeEvery<any>(TransactionActionTypes.DOWNLOAD_CSV, callDownloadCsv);
}